import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Patents from "../pages/patents/page";
import IR from "../pages/ir/page";
import RND from "../pages/rnd/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/patents",
    element: <Patents />,
  },
  {
    path: "/ir",
    element: <IR />,
  },
  {
    path: "/rnd",
    element: <RND />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;